import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import { Formik } from "formik";
import { signOut } from "../../models/actions/authActions";
import bg from "../../assets/img/bg-half.png";
import EQBrandLogo from "../../assets/img/ecosense-brand-logo-negative-white.png";
import EQBrand from "../../assets/img/ecosense-brandmark-positive.png";
import EQLogo from "../../assets/img/EQ200_Logo_wh2.png";

import {
  Button,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import "../../assets/css/common.css";
import InputBase from "@material-ui/core/InputBase";
import EcoButton from "../../components/EcoButton";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)}px;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: ${(props) => props.theme.spacing(10)}px;
    padding-bottom: ${(props) => props.theme.spacing(10)}px;
    padding-left: ${(props) => props.theme.spacing(15)}px;
    padding-right: ${(props) => props.theme.spacing(15)}px;
  }
`;

function ResetPwdConfirm() {
  const dispatch = useDispatch();
  const history = useHistory();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up(1617));

  return (
    <Grid
      container
      direction="row"
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
      }}
    >
      {matches && (
        <Grid
          xs={6}
          item
          style={{
            backgroundImage: `url(${bg})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundColor: "#3DB5E6",
            width: "100vw",
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Grid item style={{ marginTop: "auto" }}>
            <img
              style={{
                width: "100%",
                height: "80px",
                objectFit: "contain",
              }}
              src={EQLogo}
              alt="ecosense logo"
            />
          </Grid>
          <Grid item>
            <Typography
              variant="h1"
              style={{
                marginTop: 26,
                textAlign: "center",
                color: "white",
                fontFamily: "avenir",
                fontWeight: "500",
                width: "100%",
              }}
            >
              Radon Testing with Ecosense Solution Fast and Accurately
            </Typography>
          </Grid>
          <Grid item style={{ marginTop: "auto" }}>
            <img
              style={{
                width: "100%",
                height: "200px",
                objectFit: "contain",
              }}
              src={EQBrandLogo}
              alt="ecosense brand logo"
            />
          </Grid>
        </Grid>
      )}
      <Grid
        item
        xs={matches ? 6 : 12}
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
        }}
      >
        <Wrapper>
          <Helmet title="Reset Password" />
          <div align="center">
            <img
              style={{
                width: "200px",
                height: "150px",
                objectFit: "contain",
              }}
              src={EQBrand}
              alt="ecosense brand"
            />
          </div>
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Reset password
          </Typography>
          <div className="s20"></div>
          <Typography component="h2" variant="body1" align="center">
            Your password was successfully reset!
          </Typography>
          <Typography
            component="h2"
            variant="body1"
            align="center"
          ></Typography>

          <Formik
            initialValues={{
              submit: false,
            }}
            onSubmit={async (
              values,
              { setErrors, setStatus, setSubmitting }
            ) => {
              try {
                dispatch(signOut());
                history.push("/auth/sign-in");
              } catch (error) {
                let message = error.message || "Something went wrong";
                setStatus({ success: false });
                setErrors({ submit: message });
                setSubmitting(false);
              }
            }}
          >
            {({ handleSubmit, isSubmitting }) => (
              <form noValidate onSubmit={handleSubmit}>
                <InputBase disabled inputProps={{ "aria-label": "naked" }} />
                <InputBase disabled inputProps={{ "aria-label": "naked" }} />
                <EcoButton
                  type="submit"
                  fullWidth
                  variant="contained"
                  classes={{ root: "button", label: "button-label" }}
                >
                  OK
                </EcoButton>
              </form>
            )}
          </Formik>
        </Wrapper>
      </Grid>
    </Grid>
  );
}

export default ResetPwdConfirm;
